import {appendToUrl} from '../services/utils';
import Product from '../product';
import Callout from './callout';

class minicart {
    constructor() {
        this.miniCart = $('.mini-cart');
        this.miniCartContent = $('.mini-cart-content');
        this.miniCartSpinner = $('.mini-cart-spinner');
        this.miniCartQty = $('.minicart-quantity').eq(0);
    }

    run() {
        // Initially hide the header-popup to ensure it is not visible before user interaction
        // preventing display issues or an uninitialized state.
        this.miniCart.find('.header-popup').hide();

        $('.mini-cart').on('count:update', (event, count) => {
            if (count && $.isNumeric(count.quantityTotal)) {
                this.updateCount(count.quantityTotal);
            }
        });

        if (['small', 'medium'].indexOf(Foundation.MediaQuery.current) === -1) this.toggleMinicart();
    }

    toggleMinicart() {
        $('.mini-cart .mini-cart-link').mouseenter((e) => {
            const popupEl = this.miniCart.find('.header-popup');
            popupEl.show();
            let recommProd = [];

            const count = parseInt(this.miniCartQty.text(), 10);

            if (popupEl.length > 0) {
                popupEl.find('[id^="cq_recomm_slot-"] .js-recomm-prod').each(function (i, select) {
                    let categories = (typeof select.dataset.category !== 'undefined') ? select.dataset.category : '';
                    categories = categories.split('/');

                    var discount = select.dataset.discount;

                    recommProd.push({
                        item_id: (typeof select.dataset.pid !== 'undefined') ? select.dataset.pid : '',
                        item_name: (typeof select.dataset.name !== 'undefined') ? select.dataset.name : '',
                        currency: currentCurrency,
                        discount: Number(discount),
                        index: i + 1,
                        item_brand: 'twinset milano',
                        item_category: categories.length > 0 ? categories[0] : '',
                        item_category2: categories.length > 1 ? categories[1] : '',
                        item_category3: categories.length > 2 ? categories[2] : '',
                        item_list_name: 'suggeriti-minicart',
                        item_variant: select.dataset.color_name,
                        price: (typeof select.dataset.price !== 'undefined') ? parseFloat((Number(select.dataset.price.split(' ')[1]) - Number(discount)).toFixed(2)) : '',
                        quantity: 1,
                        item_availability: select.dataset.item_availability,
                        item_discount_tag: discount !== '0.00' ? 'on_sale' : 'not_on_sale',
                        available_size_percentage: Number(select.dataset.available_size_percentage),
                        item_size: '',
                        item_url: select.dataset.master_url,
                        item_img: select.dataset.default_color_image
                    });
                });

                if (recommProd.length > 0) {
                    dataLayer.push({
                        'event': 'view_item_list',
                        'ecommerce': {
                            currency: currentCurrency,
                            items: recommProd
                        }
                    });
                }
            }


            if (count !== 0) {
                this.loadMiniCart();
            }
        });
    }

    loadMiniCart() {
        const count = parseInt(this.miniCartQty.text(), 10);
        const url = this.miniCart.data('action-url');
        this.miniCartSpinner.show();
        var einstein = this.miniCartContent.find('.einstein-container');

        $.get(url, data => {
            this.miniCartContent.empty().append(data).append(einstein);

            let popup = $(".mini-cart .header-popup");
            const isLandscape = window.matchMedia("(orientation: landscape)").matches;
            const maxHeight = window.innerHeight * (isLandscape ? 0.75 : 0.88);

            var isEinsteinScrollable = false;
            if(einstein.find('.items').length > 0){
                var eisteinList = einstein.find('.items')[0];
                isEinsteinScrollable = eisteinList.scrollHeight > eisteinList.clientHeight;
            }

            if (popup.length > 0 && popup[0].scrollHeight > maxHeight && isEinsteinScrollable) {
                this.miniCartContent.addClass("same-space-partition");
            } else {
                this.miniCartContent.removeClass("same-space-partition");
            }

            if(einstein.find('.items').length === 0){
                this.miniCartContent.css("grid-template-rows", '1fr auto');
            }

            this.miniCartSpinner.hide();
            this.updateCount(count);

            $('.mini-cart-content .js-empty-cart-trigger').click((e) => {
                e.preventDefault();
                const modalid = $(e.currentTarget).data('open');

                var modal = new Foundation.Reveal($(`#${modalid}`));
                modal.open();
            });

            $('.mini-cart-content .remove-line-item a').click(e => {
                const actionUrl = $(e.currentTarget).data('action');
                const productID = $(e.currentTarget).data('pid');
                const productName = $(e.currentTarget).data('name');
                const uuid = $(e.currentTarget).data('uuid');

                var removePopup = new Foundation.Reveal($(`#removeProductModal-${uuid}`));
                removePopup.open();

                $(document).on('closed.zf.reveal', `#removeProductModal-${uuid}`, e => {
                    $(e.target).parent().remove();
                    setTimeout(() => {
                        this.miniCart.removeClass('popup-open');
                    }, 2000);
                });

                this.miniCart.addClass('popup-open');

                this.removeProduct(actionUrl, productID, productName, uuid);
            });
        });
    }

    removeProduct(actionUrl, productID, productName, uuid) {
        $(`#removeProductModal-${uuid} .cart-delete-confirmation-btn`).on('click', e => {
            e.preventDefault();

            const url = appendToUrl(actionUrl, {
                pid: productID,
                uuid: uuid
            });

            this.miniCartSpinner.show();

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: data => {
                    if ($('.row-basket-items').length) {
                        document.location.reload();
                    } else {
                        this.updateCount(data.basket.numItems);
                        this.miniCartSpinner.hide();
                        this.loadMiniCart();

                        setTimeout(() => {
                            this.miniCart.removeClass('popup-open');
                        }, 2000);
                    }
                    dataLayer.push({
                        event: 'remove_from_cart',
                        ecommerce: Product.getDataLayerGA4(
                            data.basket,
                            data.removedItemModel,
                            "remove_from_cart",
                            false
                        )
                    });
                },
                error: err => {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        Callout.error('', err.responseJSON.errorMessage, this.miniCartContent);
                        this.miniCartSpinner.hide();
                    }

                    setTimeout(() => {
                        this.miniCart.removeClass('popup-open');
                    }, 2000);
                }
            });
        });
    }

    updateCount(count) {
        $('.minicart-quantity').text(count);
    }
}

const Minicart = new minicart();
export default Minicart;


// WEBPACK FOOTER //
// ./assets/scripts/components/minicart.js